import { Component, OnInit, TemplateRef } from '@angular/core';
import { Businessunit } from './businessunit';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, PatternValidator } from '@angular/forms';
import { BusinessunitService } from './businessunit.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-businessunit',
  templateUrl: './businessunit.component.html',
  styleUrls: ['./businessunit.component.css']
})
export class BusinessunitComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'Business Unit';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  businessunitForm: FormGroup;
  businessunits: Businessunit[] = [];
  businessunitsactive: Businessunit[] = [];
  businessunit: Businessunit;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  businessunitModalRef: BsModalRef;
  operation: string;
  userid: number;
  businessunitid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'businessunit'; //set default
  reverse: boolean = false;

  constructor(
    private businessunitservice: BusinessunitService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      //console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('BusinessUnit_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('BusinessUnit_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('BusinessUnit_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('BusinessUnit_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.businessunitForm = this.formBuilder.group({
      businessunitid: [''],
      businessunit: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }
    
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.businessunits = [];
    this.businessunitsactive = [];
    this.businessunitservice.Get().subscribe(res => {
      this.businessunits = res;
      if (this.showallstatus == true) {
        this.businessunits.forEach(data => {
          if (data.active == 1) {
            this.businessunitsactive.push(data);
          }
        });
        this.businessunits = [];
        this.businessunits = this.businessunitsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.businessunitsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.businessunits.forEach(data => {
        if (data.active == 1) {
          this.businessunitsactive.push(data);
        }
      });
      this.businessunits = [];
      this.businessunits = this.businessunitsactive;
    }
    else {
      this.showall = true;
      this.businessunits = [];
      this.getAll();
    }
  }

  get g() { return this.businessunitForm.controls; }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedbusinessunit");
    let data = arrays.find(ob => ob['name'] === 'Business Unit');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedbusinessunit","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedbusinessunit",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.businessunitModalRef.hide();
  }

  Post(businessunit: Businessunit) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.businessunitForm.invalid) {
    //  //console.log(this.g);
    //  //console.log(this.businessunitForm.errors);
    //}
    if ((businessunit.businessunit.trim() == undefined) || (businessunit.businessunit.trim() == '')) {
      this.toastr.error('Business Unit should not be empty');
      return;
    }
   
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    businessunit.businessunit = businessunit.businessunit.trim();
    if (this.operation == 'add') {
 
      businessunit.createdby = this.userid;
      msg = "Record Added Successfully";
      this.businessunitservice.Post(businessunit).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.businessunitModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      businessunit.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.businessunitservice.Put(businessunit).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.businessunitModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.businessunitForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.businessunitForm.value.active = 1;
    } else {
      this.businessunitForm.value.active = 0
    }
  }

  OpenConfirmTemplate(businessunit, template: TemplateRef<any>) {
  if (businessunit.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.businessunit = businessunit;
          
          this.Delete();

        }
       
      });
    
  }
  
    Delete() {
    var msg;
    if (this.businessunit.active == 0) {
      this.businessunit.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.businessunit.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.businessunit.modifiedby = this.userid;
    this.businessunitservice.Delete(this.businessunit).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
    
  hidePopup() {
    this.businessunitModalRef.hide();
  }

  openBusinessunitModal(template: TemplateRef<any>, type, businessunit?: Businessunit) {
    this.operation = type
   
    if (type == 'update') {
      this.businessunitForm.controls['businessunitid'].setValue(businessunit.businessunitid);
      this.businessunitForm.controls['businessunit'].setValue(businessunit.businessunit);
      this.businessunitForm.controls['active'].setValue(businessunit.active);
      this.businessunit = businessunit;
    }
    if (type == 'add') {
      this.businessunitForm.controls['businessunitid'].setValue(0);
      this.businessunitForm.controls['businessunit'].setValue('');
      this.businessunitForm.controls['active'].setValue(1);
    }
    this.businessunitModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }
   
}
